<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<link rel ="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"></link>
<template>
  <v-container>
    <v-layout text-center wrap>
      <span id="main_title">
        <h4>&emsp;モバイルオーダー</h4>
      </span>
      <span id="header_logo"><img src="https://misemeg.jp/appli/img/misemeg-logo.svg" width="49px" /></span>
      <v-flex xs12>
        <!-- <h1>ようこそ！ {{ name }} <b>{{ email }}</b> {{ userId }}さん</h1> -->
        <!-- <h3><v-btn large color="error" @click="logout">ログアウト</v-btn></h3> -->
        <!-- <img src='https://misemeg.jp/owner/mb/assets/images/common/misemeg_icon.svg' height="100px" width="100px"> -->
        <!-- <h4>LINEミニアプリ "みせめぐMini"</h4> -->
        <!-- <br /> -->
        <br />
        <!-- <v-btn large color="success" @click="returntop" title="ＴＯＰ画面に戻る" id="returntop_btn">ＴＯＰ画面に戻る</v-btn> -->
        <v-btn large color="success" @click="returntop" title="会員バーコード" id="returntop_btn">会員バーコード</v-btn>
        <br /><br />
        <span id="qr_text"></span>
        <br /><br />
        <span id="onetime_barcode"></span>
        <br /><br />
        <span id="member_info" hidden></span>
      </v-flex>
      <br />
      <br />
      <!-- Snackbar -->
      <div>
        <v-snackbar v-model="snackbarFlag" color="primary" multi-line :timeout="snackbarTimeout" top>
          {{ snackbarText }}
        </v-snackbar>
      </div>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <br /><br />
        <div class="ma-4">
        <span id="copyright"><a href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1" target="_blank">&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright &copy; BUSICOM.Co.,ltd. </a></span>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
.v-main {
  background-color: #f3f3f3;
}

#main_title{
  text-align:center;
  white-space: nowrap;
  display:float;
  background-color:#00843f;
  color:#ddd;
  width:100%;
  letter-spacing:1em;
  padding-top:15px;
  padding-bottom:15px;
  padding-right:50px;
  margin-top:-15px;
  margin-left:-13px;
  margin-right:-50px;
 }

#header_logo {
  display: float;
  margin-top: -50px;
}

#storeslist_tbl {
  display: fixed;
  margin: 0 auto;
  border-collapse: collapse;
  border: 0px solid #000;
  background-color: #f3f3f3;
  width: 100%;
}

#storeslist_tbl tr {
  line-height: 20px;
}

#storeslist_tbl td {
  border-collapse: collapse;
  border: 0px solid #000;
  background-color: #f3f3f3;
  text-align: left;
  padding: 0;
}

#storeslist_tbl td a {
  text-decoration: none;
}

#returntop_btn {
  width: 50%;
  font-size: large;
}

.std_row {
  background-color: #f3f3f3;
}

.title_row {
  background-color: #f3f3f3;
}

#line_logout {
  margin: 0 auto;
}

#copyright {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}

#copyright a {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}

hr {
  height: 3px;
  border: 0;
  border-color: #00843f;
  box-shadow: inset 0 12px 12px -12px rgba(168, 168, 168, 0.7);
}
</style>
<script>
// for encrypt message
import crypto from 'crypto-js';
var CryptoJS = require('crypto-js');
// var dts = new Date().getDate();
var dts = '651127';
var passPhrase = "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";

// for HTTP response
import axios from 'axios'

export default {
  data () {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: '',
      name: '',
      imgURL: '',
      userId: '',
      email: '',
      barcode_url: '',
      inClient: false
    }
  },
  created () {
    this.initializeLiff();
    //window.alert('page loaded');
  },
  mounted() {
    ;;
  },
  methods: {
    
    initializeLiff: function () {
      var me = this
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID
        },
        data => {
          me.loginCheck()
        },
        err => {
          console.log('LIFF initialization failed', err)
        }
      )
    },
    loginCheck: function () {
      var me = this

      // ログインチェック      
      if (liff.isLoggedIn()) {
        this.isClient = liff.isInClient();
        const permissionStatus = liff.permission.query("email");
        debugger;
        if (permissionStatus.state === "prompt") {
            liff.permission.requestAll();
        }
       
       const idToken = liff.getDecodedIDToken();
       console.log(idToken); // print decoded idToken object
       var email = idToken.email;
        //idToken からメールが取得出来ない場合はlocalStorageに保存したメルアド情報を取得する
        try{
          if(email=='undefined'||email==null||email==''){
             var encrypted_mail = localStorage.getItem('lmmini_' + miseid + '_maddr');
            //  window.alert(encrypted_mail);
             var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, {iv: iv,});
            //  window.alert(dec_email);
             email = dec_email.toString(CryptoJS.enc.Utf8);
            //  window.alert(email);
          } 
        }catch(Exception){
           email = '';
        }
       
      // プロフィール取得
      liff.getProfile()
        .then(profile => {
          me.name   = profile.displayName
          me.imgURL = profile.pictureUrl
          me.userId = profile.userId
          me.email  = email            
          //me.barcode_img = barcode_url
          debugger;            
        })
        .catch((err) => {
          console.log('error', err)
        })
        // md5()実行用ライブラリ読込
        var md5 = require('md5');
        // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく(午前ゼロ時をまたいでエラーになるケースはいったん無視する）
        var dt = new Date();
        var year = dt.getFullYear();
        var month = dt.getMonth()+1;
        var strMonth='';
        if(month<10){
          strMonth = '0' + month;
        }else{
          strMonth = month.toString();
        }
        var date = dt.getDate();
        var strDate = '';
        if(date<10){
          strDate = '0' + date;
        }else{
          strDate = date.toString();
        }
        var mmddyyyy= strMonth + '-' + strDate + '-' + year;
 
        //------------------------------------------
        // ＱＲリーダー起動
        //------------------------------------------
        if (liff.isInClient()) {
          liff.scanCode().then(result => {
            document.getElementById('qr_text').textContent = result.value;
            if(result.value){
                var miseid=this.$_shopid();
                //  window.alert('QRコードを読み取りました。');
                // QRコード読み取り結果のURLを分解してQueryStringのテーブル番号部分を取得する。
                const str = result.value;
                var table_number = "";
                str.split('&').forEach( function( value ) {
                    if(value.indexOf("table_no=") !== -1){
                       table_number = atob(value.replace("table_no=","")); 
                    }
                });
                //https://rearegi.karamel.jp/rearegi/servlet/mLoginServlet?company_code=51022&shop_code=651127&cust_code=67987478055000872&table_no=11
                // var rg_url="https://rearegi.karamel.jp/rearegi/servlet/mLoginServlet?company_code=";
                // rg_url += this.$_tv_compcd();
                // rg_url += "&shop_code=";
                // rg_url += this.$_shopid();
                // rg_url += "&cust_code=";
                // rg_url += $("#onetime_barcode").text();
                // rg_url += "&table_no=";
                // rg_url += table_number;
                // // window.alert(rg_url);
                // window.location.href = rg_url;
                // https://test.misemegu.jp/appli/line/jump2MobileOrder.php?compcd=51022&shopid=651127&userid=u0398110&mail=bciijima@gmail.com&security=31741d74588b1790224a065cea5da609&table=20
                var rg_url = "https://test.misemegu.jp/appli/line/jump2MobileOrder.php?compcd=";
                rg_url += this.$_tv_compcd();
                rg_url += "&shopid=";
                rg_url += this.$_shopid();
                rg_url += "&userid=";
                var encrypted_uid = localStorage.getItem('lmmini_' + miseid + '_muid');
                const dec_uid = CryptoJS.AES.decrypt(encrypted_uid, key, {iv: iv,});
                rg_url += dec_uid.toString(CryptoJS.enc.Utf8);
                rg_url += "&mail=";
                rg_url += this.$_shopid();
                rg_url += email;
                rg_url += "&security=" + md5(email + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + email + "!Busicom04510" + mmddyyyy); 
                rg_url += "&openExternalBrowser = 1";
                // window.alert(rg_url);
                window.location.href = rg_url;
            }
          }).catch(err => {
            document.getElementById('qr_text').textContent = err.message;
          });
        }
        
      } else {
        // ログインまだ
        this.$router.push({ name: 'home' })
      }
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout()
        this.$router.push({ name: 'home' })
      }
    },
    returntop: function () {
      if (liff.isLoggedIn()) {
        // line-mini トップ画面に戻る      
        this.$router.push({ name: 'login' });
      }
    },
    showSnackbar(text) {
      this.snackbarFlag = true
      this.snackbarText = text
      setTimeout(()=> {
          this.snackbarFlag = false
          this.snackbarText = ''
        },
        this.snackbarTimeout
      )
    },
    getBarcodeParam(){
      md5()
    }
    
  }
}
</script>